module.exports = __webpack_public_path__ + "img/ff4.00619097.png";